/** Allowed `source` values for ingestion keys (v1). */
export const INGESTION_SOURCE_TYPES = ['ruuvi-station'] as const;
export type IngestionSourceType = (typeof INGESTION_SOURCE_TYPES)[number];

export const SOURCE_ID_PATTERN = /^[a-z0-9][a-z0-9-]{0,39}$/;
export const SOURCE_ID_MAX = 40;
export const INGESTION_LABEL_MIN = 1;
export const INGESTION_LABEL_MAX = 80;

export interface IngestionSourceSummary {
  /** SHA-256 hash of the raw key (Firestore doc id). */
  keyHash: string;
  source: IngestionSourceType;
  sourceId: string;
  label: string;
  enabled: boolean;
  createdAtMs: number;
  lastUsedAtMs: number | null;
  lastReadingObservedAtMs: number | null;
  receivedCount: number;
}

/** Result of `createIngestionKeyCallable` / `regenerateIngestionKeyCallable`. */
export interface NewIngestionKeyResult {
  keyHash: string;
  rawKey: string;
  ingestUrl: string;
  source: IngestionSourceType;
  sourceId: string;
  label: string;
  createdAtMs: number;
}

// ─── Callable contracts ──────────────────────────────────────────────────────

export interface CreateIngestionKeyPayload {
  homeId: string;
  source: IngestionSourceType;
  sourceId: string;
  label: string;
}

export interface SetIngestionKeyEnabledPayload {
  homeId: string;
  keyHash: string;
  enabled: boolean;
}

/** `listIngestionSourcesCallable` result. */
export interface ListIngestionSourcesResult {
  keys: IngestionSourceSummary[];
}
